import { ChangeDetectorRef, OnInit, } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore, toNumber, } from '@freelancer/datastore';
import { PaymentsCart, } from '@freelancer/payments-cart';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { InputType } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight } from '@freelancer/ui/text';
import { maxLength, pattern, required } from '@freelancer/ui/validators';
import * as Rx from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
var MilestoneCreateModalComponent = /** @class */ (function () {
    function MilestoneCreateModalComponent(modalRef, datastore, router, cart, auth, abtest, changeDetectorRef, uiConfig) {
        this.modalRef = modalRef;
        this.datastore = datastore;
        this.router = router;
        this.cart = cart;
        this.auth = auth;
        this.abtest = abtest;
        this.changeDetectorRef = changeDetectorRef;
        this.uiConfig = uiConfig;
        this.Margin = Margin;
        this.BannerAlertType = BannerAlertType;
        this.ButtonColor = ButtonColor;
        this.FontWeight = FontWeight;
        this.HeadingSize = HeadingSize;
        this.HeadingType = HeadingType;
        this.InputType = InputType;
        this.isBusy = false;
        this.showError = false;
    }
    MilestoneCreateModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        // set up input formgroup
        this.formGroup = new FormGroup({
            amount: new FormControl('', [
                required('Amount field is required'),
                pattern(/^[1-9][0-9]*$/, 'Invalid amount specified'),
            ]),
            description: new FormControl('', [
                required('Description is required'),
                maxLength(200, 'Please create a shorter description.'),
            ]),
        });
        if (this.abtest.isWhitelistUser()) {
            this.inTest$ = Rx.of(true);
        }
        else if (this.uiConfig.theme === 'arrow') {
            this.inTest$ = Rx.of(false);
        }
        else {
            this.inTest$ = Rx.combineLatest(this.auth.getUserId(), this.datastore
                .collection('projectViewProjects', function (query) {
                return query.where('id', '==', _this.projectId).limit(1);
            })
                .valueChanges()).pipe(switchMap(function (_a) {
                var authId = _a[0], projects = _a[1];
                // non-English projects or projects with local jobs not in the test
                if (!projects[0].language.includes('en') || projects[0].local) {
                    return Rx.of(false);
                }
                // pushed to 100% for new employer
                if (toNumber(authId) > 33337777) {
                    return Rx.of(true);
                }
                // existing employer
                return _this.abtest
                    .getUserExperimentVariation('T65827-employer-pvp-webapp-v3')
                    .pipe(map(function (variation) { return variation === 'test'; }));
            }));
        }
    };
    // Create milestone without cart
    MilestoneCreateModalComponent.prototype.createMilestone = function () {
        var _this = this;
        this.isBusy = true;
        this.datastore
            .createObject('milestones', {
            id: Date.now(),
            projectId: this.projectId,
            bidderId: this.bidderId,
            amount: toNumber(this.formGroup.controls.amount.value),
            description: this.formGroup.controls.description.value,
            currency: this.currencyDetails,
            timeCreated: Date.now(),
        })
            .then(function (res) {
            if (res.status === 'success') {
                _this.modalRef.close(true);
            }
            else if (res.errorCode === 'PAYMENT_REQUIRED') {
                _this.modalRef.close(true);
                // if it fails due to insufficient funds, redirect to deposit page
                // refAction = create_milestone handles the dataToken for us
                var queryParams = {
                    amount: toNumber(_this.formGroup.controls.amount.value),
                    bidderId: _this.bidderId,
                    currency: _this.currencyDetails.id,
                    descr: _this.formGroup.controls.description.value,
                    id: _this.projectId,
                    refAction: 'create_milestone',
                    username: _this.username,
                    checkBalance: true,
                };
                _this.router.navigate(['/deposit'], { queryParams: queryParams });
            }
            else {
                // otherwise show the generic error
                _this.showError = true;
                _this.isBusy = false;
                _this.changeDetectorRef.markForCheck();
            }
        });
    };
    /**
     * 1. create cart
     * 2. create milestone draft
     * 3. create cart item
     * 4. add project fee cart item if hourly
     * 5. If success, to payment page, all errors in all steps show and break promise
     *
     */
    MilestoneCreateModalComponent.prototype.createMilestoneCart = function () {
        var _this = this;
        this.createMilestonePromise = this.createMilestoneDraft(this.formGroup)
            .then(function (milestoneDraftResponse) {
            if (milestoneDraftResponse.status !== 'success') {
                throw milestoneDraftResponse;
            }
            var milestoneRequestCartItem = _this.transformMilestoneRequestToCartItem(_this.formGroup, milestoneDraftResponse.id);
            return Rx.combineLatest(_this.datastore
                .document('projectViewProjects', _this.projectId)
                .valueChanges(), _this.datastore
                .collection('hourlyContracts', function (query) {
                return query.where('projectId', '==', _this.projectId);
            })
                .valueChanges())
                .pipe(take(1))
                .toPromise()
                .then(function (_a) {
                var project = _a[0], hourlyContracts = _a[1];
                // if it's hourly, we need to attach a project fee cart item
                if (project.hourlyProjectInfo && hourlyContracts.length > 0) {
                    return _this.datastore
                        .collection('hourlyProjectMilestoneFees', function (query) {
                        return query
                            .where('projectId', '==', _this.projectId)
                            .where('milestoneAmount', '==', toNumber(_this.formGroup.controls.amount.value));
                    })
                        .valueChanges()
                        .pipe(take(1), map(function (res) { return res[0]; }))
                        .toPromise()
                        .then(function (r) {
                        var fee = r.fee, currencyId = r.currencyId;
                        var projectFeeItem = _this.transformProjectFeeToCartItem(milestoneDraftResponse.id, currencyId, fee);
                        return [projectFeeItem, milestoneRequestCartItem];
                    });
                }
                return [milestoneRequestCartItem];
            });
        })
            .then(function (items) {
            return _this.cart.handle("Chat box create milestone for project " + _this.projectId, {
                destination: "project_view_page" /* PROJECT_VIEW_PAGE */,
                payload: "" + _this.projectId,
            }, items);
        });
    };
    MilestoneCreateModalComponent.prototype.createMilestoneDraft = function (milestoneForm) {
        var milestoneDraft = {
            amount: Number(milestoneForm.value.amount),
            bidderId: this.bidderId,
            bidId: this.bidId,
            currencyId: this.currencyDetails.id,
            description: milestoneForm.value.description,
            id: Date.now(),
            milestoneRequestId: undefined,
            projectId: this.projectId,
            projectOwnerId: Date.now(),
            timeCreated: Date.now(),
            transactionId: undefined,
        };
        return this.datastore.createObject('milestoneDrafts', milestoneDraft);
    };
    MilestoneCreateModalComponent.prototype.transformMilestoneRequestToCartItem = function (milestoneForm, milestoneDraftId) {
        return {
            contextType: "milestone" /* MILESTONE */,
            contextId: String(milestoneDraftId),
            description: milestoneForm.value.description,
            currencyId: this.currencyDetails.id,
            amount: Number(milestoneForm.value.amount),
            useBonus: true,
        };
    };
    MilestoneCreateModalComponent.prototype.transformProjectFeeToCartItem = function (milestoneDraftId, currencyId, fee) {
        return {
            contextType: "project_fee" /* PROJECT_FEE */,
            contextId: "" + milestoneDraftId,
            description: 'Project fee',
            currencyId: currencyId,
            amount: fee,
            useBonus: false,
        };
    };
    MilestoneCreateModalComponent.prototype.cancel = function () {
        this.modalRef.close(false);
    };
    return MilestoneCreateModalComponent;
}());
export { MilestoneCreateModalComponent };
